// Transfer store for preloaded data between LoginPage and ManagerReport
// Uses a module-level variable instead of route state to avoid browser
// History API size limits (2-16 MB depending on browser)
let data = null;

export const setPreloadedData = (d) => { data = d; };
export const consumePreloadedData = () => { const d = data; data = null; return d; };
